// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2bkvz","search":"Settings_search__2tdMn","filter":"Settings_filter__2QCwg"};